"use client";

import Input, { InputRef } from 'rc-input';
import Textarea, { TextAreaRef } from 'rc-textarea';

import { forwardRef } from "react";
import {
  InputFieldInstance,
  InputFieldProps,
  TextAreaFieldInstance,
  TextAreaFieldProps,
} from "./types";
import { useOspInputField } from "./useOspInputField";

export const InputField = forwardRef<InputFieldInstance, InputFieldProps>(
  (props, ref) => {
    const { borderVisible, formatter, placeholderColor, classNames, inputClassName, containerClassName, focusBorderColor, ...restProps } = props;
    const { onBlur, onFocus, onChangeText, styles, cx, inputRef, sizeTextClassName } =
      useOspInputField<InputRef>(props, ref);

    return (
      <div className={cx(styles.rootContainer, containerClassName)}>
        <Input
          {...restProps}
          ref={inputRef}
          classNames={{
            ...classNames,
            prefix: cx(styles.prefix, classNames?.prefix, !!restProps.prefix && styles.marginPrefix),
            suffix: cx(styles.suffix, classNames?.suffix, (!!restProps.suffix || !!restProps.allowClear) && styles.marginSuffix),
            affixWrapper: cx(styles.affixWrapper, classNames?.affixWrapper),
            input: cx(sizeTextClassName, inputClassName, classNames?.input),
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChangeText}
        />
      </div>

    );
  },
);

export const TextAreaField = forwardRef<
  TextAreaFieldInstance,
  TextAreaFieldProps
>((props, ref) => {
  const { borderVisible, formatter, placeholderClass, inputClassName, containerClassName, classNames, styles: propStyles, placeholder, placeholderColor, ...restProps } = props;

  const { onBlur, onFocus, onChangeText, styles, cx, inputRef, sizeTextClassName, inlineTextareaStyles } =
    useOspInputField<TextAreaRef>(props, ref);

  // Use space placeholder to activate :placeholder-shown pseudo-class
  const actualPlaceholder = " ";

  return (
    <div className={cx(styles.rootContainer, styles.textAreaContainer, containerClassName)}>
      <Textarea
        {...restProps}
        placeholder={actualPlaceholder}
        classNames={{
          ...classNames,
          prefix: cx(styles.prefix, classNames?.prefix, !!restProps.prefix && styles.marginPrefix),
          suffix: cx(styles.suffix, classNames?.suffix, (!!restProps.suffix || !!restProps.allowClear) && styles.marginSuffix),
          affixWrapper: cx(styles.affixWrapper, classNames?.affixWrapper),
          textarea: cx(styles.textArea, sizeTextClassName, inputClassName, classNames?.textarea),
        }}
        styles={{
          ...propStyles,
          textarea: {
            ...inlineTextareaStyles,
            ...propStyles?.textarea,
          },
        }}
        ref={inputRef}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChangeText}
      />
      {/* Simulated placeholder with gradient shine animation */}
      {placeholder && (
        <span className={cx(
          styles.placeholderText,
          sizeTextClassName,
          "placeholder-text",
          !placeholderColor && "text-content_quaternary",
          placeholderClass,
        )}>
          {placeholder}
        </span>
      )}
    </div>

  );
});

 
// @ts-ignore
if (process.env.NODE_ENV !== "production") {
  InputField.displayName = "InputField";
  TextAreaField.displayName = "TextAreaField";
}
